import { render, staticRenderFns } from "./ArquivoAprovado.vue?vue&type=template&id=317ecb11&scoped=true"
import script from "./ArquivoAprovado.vue?vue&type=script&lang=js"
export * from "./ArquivoAprovado.vue?vue&type=script&lang=js"
import style0 from "./ArquivoAprovado.vue?vue&type=style&index=0&id=317ecb11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317ecb11",
  null
  
)

export default component.exports